<template>
  <el-container class="curri_content">
    <el-header>
      <index-header></index-header>
    </el-header>
    <el-main>
      <div class="mainContent">
        <p @click="back()" style="margin-bottom:10px;cursor: pointer;"><i class="icon el-icon-arrow-left"></i>{{$t('global.backToSchedule')}}</p>
        <div class="main-arrow">
          <div class="flex_column">
            <h3 class="font_36_reg">{{$t('recharge.topup')}}</h3>
            <h3 class="font_36_reg"><p>{{$t('recharge.currentCredit')}}:</p>
            {{balance.balance_valid}}</h3>
          </div>
          <div class="main-info">
            <div>
              <p>{{$t('recharge.manyCredit')}}</p>
              <p>{{$t('recharge.selectPackage')}}</p>
            </div>
            <div class="select-part">
              <div class="addForm">
                <div :class="item.selected?'addFormList selected':'addFormList'" v-for="(item,i) in listData" :key='i' @click="selectTop(item)">
                  <p class="font_18_bold title">{{item.title}}</p>
                  <div class="flex_column_justify_evenly price">
                    <p class="font_24_bold">${{item.price}} USD</p>
                    <p class="font_18_reg">{{$t('recharge.empty')}} {{item.quantity}} {{$t('recharge.credits')}}</p>
                    <p class="font_18_reg" v-if="item.extra_quantity">({{$t('recharge.extra')}} <b>{{$t('recharge.free')}}</b> {{$t('recharge.credits')}}: {{item.extra_quantity}})</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex_justify_center"><el-button type="primary" @click="toPay">{{$t('recharge.toPay')}}</el-button></div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <index-footer></index-footer>
    </el-footer>
  </el-container>
</template>

<script>
import IndexHeader from './views/header'
import IndexFooter from './views/footer'
import store from '@/store/store'
import { setStore, getStore, keys } from '@/store';
export default {
  components: {
    IndexHeader,
    IndexFooter
  },
  data () {
    return {
      listData: [],
      balance: {},
      theSelect: {},
      handleResultNew: function (result) {
        if (result.error) {
          alert('failed')
        }
      }
    }
  },
  // watch:{
  //   //监控列表总数据量的变化
  //   datacourse(newVal,oldVal){
  //       //当总数据量变化时，重新计算分页的数量（需要显示多少页）
  //       this.data =newVal;
  //   }
  // },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/sinadd'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    this.balance = getStore(keys.userBalance)
    this.getChild()
  },
  methods: {
    back () {
      if (this.$route.query.type == 'credit') {
        this.$router.push({ path: '/payHistory' })
      } else {
        this.$router.push({ path: '/index' })
      }
    },
    getChild () {
      this.$http.get('/api/recharge/quantity').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.listData = res.data.data
          // store.setChildList(res.data.data)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    selectTop (item) {
      this.listData.map((i) => {
        if (i.id == item.id) {
          i.selected = true
          this.theSelect = item
        } else {
          i.selected = false
        }
      })
      this.$forceUpdate()
      // this.$router.push({ path: '/add?one=1&edit=' + encodeURIComponent(JSON.stringify(item)) })
    },
    // toPay () {
    //   let that = this
    //   that.$http.post('/api/testStripe', {
    //     lessons_goods_id: this.theSelect.id
    //   })
    //     .then(function (session) {
    //       var stripe = Stripe(session.data.sessionId)
    //       return stripe.redirectToCheckout({ sessionId: session.data.sessionId })
    //     })
    // },
    createCheckoutSession () {
      let that = this
      return new Promise((resolve, reject) => {
        that.$http.post('/api/testStripe', {
          lessons_goods_id: this.theSelect.id
        })
          .then(res => {
            console.log(res)

            store.setPayData(this.theSelect)
            resolve(res.data.sessionId)
            return res.data.sessionId
          })
      })
    },
    toPay () {
      var that = this
      if (!this.theSelect.id) {
        this.$message({
          message: this.$t('recharge.selectPackage'),
          type: 'warning'
        })
        return false
      }
      var stripe = Stripe('pk_live_51H2iOSLvUcRqAd8piK4KqTRgmvlxgG1S7pMoER8Ike9oBpfOtVzEjzQWiErwW4kbxDOiQ9xkKETm60RXQcEXx108007VlSNnrR')
      // var stripe = Stripe('pk_test_51H2iOSLvUcRqAd8paHZmX26Fkazd889p8f7lw8kBXdsDDsosvXZf1GQNFdTrx2EcQxlHMQklcjL7ie3WfnTgjAgj00Y1lnu2NJ')
      this.createCheckoutSession().then(data => {
        stripe
          .redirectToCheckout({
            sessionId: data
          })
          .then(this.handleResultNew)
      })
    }

  }
}
</script>

<style lang="less" scoped>
.curri_content{
  position: relative;
  .el-header{
    height: 88px!important;
    background: rgba(53,54,67,0.90);
    width: 100%;
    padding:0;
  }
  .el-main{
    overflow: inherit;
    padding:0;
    margin-bottom:254px;
      z-index:22;
    .mainContent{
      width:1200px;
      margin:25px auto 54px;
      .main-arrow{
        background: #FFFFFF;
        border: 1px solid #FFD1C6;
        border-radius: 5px;
        // padding:40px;
        margin: 10px 100px;
        // button{
        //   width: 120px;
        //   height: 40px;
        //   background: #ff6440;
        //   border-radius: 4px;
        //   border: 1px solid #ff6440;
        //   margin-top: 20px;
        //   margin-bottom: 15px;
        //   color: #fff;
        //   font-size: 16px;
        //   font-family: Sofia Pro-Bold;
        //   box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
        // }
        .flex_column{
          height:150px;
          padding:25px 40px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border-bottom: 1px solid rgba(165, 165, 165, 0.5);
          h3{
            font-weight: normal;
            p{
              font-size: 18px;
            }
          }
        }
        .main-info{
          padding:25px 40px;
          p{
            font-size: 18px;
          }
          .select-part{
            border-radius: 5px;
            padding:23px 0;
            .addForm{
              display: flex;
              flex-wrap: wrap;
              .addFormList{
                  width: 224px;
                  border-radius: 5px;
                  border: 3px solid rgba(165, 165, 165, 0.3);
                  padding: 0 13px 13px;
                  margin-right:25px;
                  margin-bottom:30px;
                  color:#424347;
                  display: flex;
                  flex-direction: column;
                  cursor: pointer;
                  overflow: hidden;
                  &:nth-child(3n){
                    margin-right:0;
                  }
                  .title{
                    margin-top: -1px;
                    padding:14px;
                    border-bottom:1px solid rgba(165, 165, 165, 0.5);
                  }
                  .price{
                    height: 150px;
                  }
                  &:hover{
                    box-shadow:0px 4px 4px rgba(0, 0, 0, 0.05);
                  }
              }
              .selected{
                width: 250px;
                padding:0 0 13px;
                border: 3px solid #FF6440;
                box-shadow: 4px 4px 5px rgba(255, 100, 64, 0.15);
                .title{
                  color:#fff;
                  background: #FFB800;
                  border:none;
                }
                &:hover{
                  box-shadow: 4px 4px 5px rgba(255, 100, 64, 0.15);
                }

              }
            }
          }
          button{
            width: 311px;
            height: 60px;
            background: #ff6440;
            border-radius: 4px;
            border: 1px solid #ff6440;
            margin-top: 20px;
            margin-bottom: 15px;
            color: #fff;
            font-size: 16px;
            font-family: Sofia Pro-Bold;
            box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
          }
        }
      }
    }
  }
  .el-footer{
    width:100%;
    height:inherit!important;
    padding:0;
    position: absolute;
    bottom:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue